import Vue from 'vue'

export const Contact = Vue.component('contact-us-form', require('./ContactUsFrom'));



// WEBPACK FOOTER //
// ./resources/assets/js/views/contact_us/index.js